import { map, number } from 'mathjs';
import React, { useEffect, useState } from 'react'
import Sketch from "react-p5";
import './Game2.css';
import Tile from './Tile';

import Predict_2048 from './Predict_2048';

function Game2() {
    
    let canvas;
    let canvas_width;
    let canvas_height;
     canvas_height=window.innerHeight*0.85;
    canvas_width=window.screen.width/2;
    
    let cell_size=100;
    let border_thickness=10;
    let line_length=4*cell_size+4*border_thickness;

    let grid_state=[];

    let number_state=[];
    let p5_loc;

    let get_random= ()=>{
        let a=Math.random();
        if(a>0.6)
            return 4;
            return 2;
    }

    let get_start_number = ()=>{
        let a=Math.random();
        if(a>0.75)
            return get_random();
        return 0;
    }


    let restart = (p5)=>{
        cts=false;
        number_state=[]

        for(let i=0;i<16;i++)
        {
            number_state.push(get_start_number())
        }

        // number_state=[
        //     0,0,0,2,
        //     0,0,0,2,
        //     0,0,0,2,
        //     0,0,0,2,
        // ]

        // number_state=[
        //     4,32,8,4,
        //     2,4,2,32,
        //     32,128,256,512,
        //     4,4,16,4
        // ]

        // number_state=[
        //     2,2,4,4,
        //     2,2,4,0,
        //     4,4,4,4,
        //     8,8,0,8
        // ]

        // number_state=[4, 8, 16, 4, 2, 32, 512, 8, 4, 128, 1024, 16, 2, 16, 8, 2]



        grid_state=[];  
        for(let i=0;i<16;i++)
        {
            let v=number_state[i];
            let xi=i%4;
            let yi=Math.floor(i/4);
            grid_state.push(new Tile(v,xi,yi,cell_size,border_thickness, p5,number_state));
         }
    }
    
    const setup = (p5, canvasParentRef) => {
    
        // canvas=p5.createCanvas(canvas_width, canvas_height).parent(canvasParentRef)
        canvas=p5.createCanvas(line_length*1.1, line_length*1.1).parent(canvasParentRef)
        
        draw_env(p5);
        p5_loc=p5;

        restart(p5);

        grid_state.map((a)=>
        a.show())

    }


    let draw_env=(p5)=>{
        let y_offset=border_thickness;
        let x_offset=border_thickness;

        p5.noFill();
        p5.stroke(0);
        p5.rect(0,0,canvas_width,canvas_height);
        p5.background("#FAF8EF"); 

        p5.fill("#CDC1B4");
        p5.noStroke();
        p5.rect(x_offset/2,y_offset/2,line_length+x_offset/2,line_length+y_offset/2);
        
        p5.stroke("#F77C5F");
        p5.stroke("#BBADA0");

        for(let i=1;i<=5;i++)
        {
            let z=(i-1)*(cell_size+border_thickness);
            p5.strokeWeight(border_thickness);
            p5.line(z+border_thickness,0+y_offset,z+border_thickness,line_length+y_offset);
    
        }

        //horizontal lines
        for(let i=1;i<=5;i++)
        {
            let y=(i-1)*(cell_size+border_thickness);
            p5.strokeWeight(border_thickness);
            p5.line(0+x_offset,y+y_offset,line_length+x_offset,y+y_offset);
    
        }
    }

    const draw = p5 => {
        draw_env(p5);
        grid_state.map((a)=>
        a.show())
    }


    let move_simulation = ()=>{
        console.log("move simulation");
        let best_des=Predict_2048(number_state);
        let kv='a';
        if(best_des==0) 
        {
            window.dispatchEvent(new KeyboardEvent('keydown', {
                'key': 'w'
              }));
              window.dispatchEvent(new KeyboardEvent('keyup', {
                'key': 'w'
              }));

        }
        else if(best_des==1) {
            window.dispatchEvent(new KeyboardEvent('keydown', {
                'key': 'd'
              }));
              window.dispatchEvent(new KeyboardEvent('keyup', {
                'key': 'd'
              }));
        }
        else if(best_des==2) {
            window.dispatchEvent(new KeyboardEvent('keydown', {
                'key': 's'
              }));
              window.dispatchEvent(new KeyboardEvent('keyup', {
                'key': 's'
              }));
        }
        else if(best_des==3) {
            window.dispatchEvent(new KeyboardEvent('keydown', {
                'key': 'a'
              }));
              window.dispatchEvent(new KeyboardEvent('keyup', {
                'key': 'a'
              }));
        }
        // console.log(best_des+"  "+kv);
    }

    const mousePressed = p5 =>{
        // move_simulation();        
    }

    let shift_right=(A,i)=>{
        //that index i is the stuff into ehich the first move takes place
        let B=A.slice();
        for(let k=i;k>0;k--)
        {
            B[k]=A[k-1]
        }
        B[0]=0;
        return B;
    }
    
    let shift_left=(A,i)=>{
        //that index i is the stuff into ehich the first move takes place
        let B=A.slice();
        for(let k=i;k<3;k++)
        {
            B[k]=A[k+1]
        }
        B[3]=0;
        return B;
    }

    let non_zero_exists=(A,bi,ind)=>{
        // non_zero_exists_less_than_index
          let flag=false;
          for(let i=bi;i<=ind;i++)
          {
              if(A[i]!=0)
              {
                    // console.log("non zero value:"+A[ind]+" index"+ind);
                  return true;
              }
          }
          return false;
      }

      let go_left=()=>{
        console.log("pressed left");
        let num=number_state;
        let new_num=[];
        let dummy=new Tile(0,0,0,17,border_thickness,p5_loc,[1,2,3]);
        for(let i=0;i<4;i++)
        {
            let ind=i*4;
            let row=[num[ind],num[ind+1],num[ind+2],num[ind+3]];
          
            let row_graphics=[dummy,dummy,dummy,dummy]

            grid_state.map((item)=>{
                if(item.y===i&&item.number!==0)
                {
                    row_graphics[item.x]=item;
                    // console.log(item.number+" at "+"("+item.x+","+item.y+")")
                }
            })

            let copy_row=row;
            console.log(copy_row+" -->");

            //merging part
            for(let j=0;j<3;j++)
            {
                for(let k=j+1;k<=3;k++)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                        row[j]*=2;
                            row_graphics[j].double_val();
                        row[k]=0;
                            row_graphics[k].zero_val();
                        break;
                    }   
                    if(row[k]!=0)
                        break;
                }
            }


            //moving part
            // for(let j=3;j>=0;j--)
            for(let j=0;j<=3;j++)
            {
                if(non_zero_exists(row,j+1,3))
                {
                    while(row[j]==0)
                    {   
                        // console.log("asking in "+j);
                        row=shift_left(row,j);
                        row_graphics.map((item,ind)=>{
                            if(ind>j)
                                item.left()
                        }
                        )

                    }
                }

            }
            console.log(row);
            new_num.push(row[0]);
            new_num.push(row[1]);
            new_num.push(row[2]);
            new_num.push(row[3]);
            
            // row_graphics[0].set_val(row[0]);
            // row_graphics[1].set_val(row[1]);
            // row_graphics[2].set_val(row[2]);
            // row_graphics[3].set_val(row[3]);
        }
        // console.log(new_num);
        // console.log(grid_state);
        number_state=new_num;
      }


      

      let go_down = ()=>{
        console.log("pressed down");
        let num=number_state;
        let new_col=[];
        let dummy=new Tile(0,0,0,17,border_thickness,p5_loc,[1,2,3]);
        
        for(let i=0;i<4;i++)
        {
            let ind=i;
            let row=[num[0*4+ind],num[ind+1*4],num[ind+2*4],num[ind+3*4]];
            let copy_row=row;
            // console.log(copy_row+" -->");

            let row_graphics=[dummy,dummy,dummy,dummy]
            grid_state.map((item)=>{
                if(item.x===i&&item.number!==0)
                {
                    row_graphics[item.y]=item;
                    // console.log(item.number+" at "+"("+item.x+","+item.y+")")
                }
            })

            //merging part
            for(let j=3;j>0;j--)
            {
                for(let k=j-1;k>=0;k--)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                        row[j]*=2;
                            row_graphics[j].double_val();
                        row[k]=0;
                            row_graphics[k].zero_val();
                            // row=shift_right(row,k);
                        break;
                        
                    }
                    if(row[k]!=0)
                        break;
                }
            }


            //moving part
            for(let j=3;j>=0;j--)
            {
                if(non_zero_exists(row,0,j-1))
                {
                    while(row[j]==0)
                    {   
                        // console.log("asking in "+j);
                        row=shift_right(row,j);
                        row_graphics.map((item,ind)=>{
                            if(ind<j)
                                item.down()
                        }
                        )
                    }
                }

            }
            // new_num.push(row[0]);
            // new_num.push(row[1]);
            // new_num.push(row[2]);
            // new_num.push(row[3]);
            for(let p=0;p<4;p++)
            new_col[p*4+ind]=row[p]

        }
        // console.log(new_col)
        number_state=new_col;
        // console.log(grid_state);

        
      }
     



    let go_right=()=>{

        console.log("pressed right");
        let num=number_state;
        let new_num=[];
        let dummy=new Tile(0,0,0,17,border_thickness,p5_loc,[1,2,3]);
        for(let i=0;i<4;i++)
        {
            let ind=i*4;
            let row=[num[ind],num[ind+1],num[ind+2],num[ind+3]];
            let row_graphics=[dummy,dummy,dummy,dummy]
           
            grid_state.map((item)=>{
                if(item.y===i&&item.number!==0)
                {
                    row_graphics[item.x]=item;
                    // console.log(item.number+" at "+"("+item.x+","+item.y+")")
                }
            })

            let copy_row=row;
            // console.log(copy_row+" -->");

            //merging part
            for(let j=3;j>0;j--)
            {
                for(let k=j-1;k>=0;k--)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                        row[j]*=2;
                            row_graphics[j].double_val();
                        row[k]=0;
                            row_graphics[k].zero_val();
                        // row=shift_right(row,k);
                        break;
                    }
                    if(row[k]!=0)
                        break;
                }
            }


            //moving part
            for(let j=3;j>=0;j--)
            {
                if(non_zero_exists(row,0,j-1))
                {
                    while(row[j]==0)
                    {   
                        // console.log("asking in "+j);
                        row=shift_right(row,j);
                        row_graphics.map((item,ind)=>{
                            if(ind<j)
                                item.right()
                        }
                        )
                        
                    }
                }

            }
            // console.log(row);
            new_num.push(row[0]);
            new_num.push(row[1]);
            new_num.push(row[2]);
            new_num.push(row[3]);
        }
        // console.log(new_num);
        number_state=new_num;
        // console.log(grid_state);

    }

    let go_up = ()=>{
        console.log("pressed up");
        let num=number_state;
        let new_col=[];
        let dummy=new Tile(0,0,0,17,border_thickness,p5_loc,[1,2,3]);
        for(let i=0;i<4;i++)
        {
            let ind=i;
            let row=[num[0*4+ind],num[ind+1*4],num[ind+2*4],num[ind+3*4]];
            let copy_row=row;
            // console.log(copy_row+" -->");
            let row_graphics=[dummy,dummy,dummy,dummy]
            
            grid_state.map((item)=>{
                if(item.x===i&&item.number!==0)
                {
                    row_graphics[item.y]=item;
                    // console.log(item.number+" at "+"("+item.x+","+item.y+")")
                }
            })

            //merging part
            for(let j=0;j<3;j++)
            {
                for(let k=j+1;k<=3;k++)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                        row[j]*=2;
                            row_graphics[j].double_val();
                        row[k]=0;
                            row_graphics[k].zero_val();
                        break;
                        
                    }
                    if(row[k]!=0)
                        break;
                }
            }


            //moving part
            // for(let j=3;j>=0;j--)
            for(let j=0;j<=3;j++)
            {
                if(non_zero_exists(row,j+1,3))
                {
                    while(row[j]==0)
                    {   
                        // console.log("asking in "+j);
                        row=shift_left(row,j);
                        row_graphics.map((item,ind)=>{
                            if(ind>j)
                                item.up()
                        })
                    }
                }

            }
            // console.log(row);
            for(let p=0;p<4;p++)
                new_col[p*4+ind]=row[p]
        }

        // console.log(new_col);
        number_state=new_col;
        // console.log(grid_state);
     
    }

    let array_eq_check =(A,B)=>{
        return JSON.stringify(A)==JSON.stringify(B)
    }

    const keyPressed = p5 =>{

        if(p5.key==" ")
        {
            move_simulation();
            return;
        }


        let ns_copy=number_state;

        if(p5.key=="a"||p5.key=="ArrowLeft")
            go_left();

        if(p5.key=="d"||p5.key=="ArrowRight")
            go_right();

        if(p5.key=="s"||p5.key=="ArrowDown")
            go_down();

        if(p5.key=="w"||p5.key=="ArrowUp")
            go_up();

        if((p5.key=="a"||p5.key=="ArrowLeft"||
        p5.key=="d"||p5.key=="ArrowRight"||
        p5.key=="s"||p5.key=="ArrowDown"||
        p5.key=="w"||p5.key=="ArrowUp")  )
        {
            if(is_game_over())
            {
                let hs=high_score(number_state);
                alert("game over max score: "+hs);
                restart(p5);
            }
            else if(!array_eq_check(ns_copy,number_state))
                add_extra_tile(p5.key)

        }
    }

    let high_score=(arr)=>{
        let max=arr[0];
        for(let i=1;i<16;i++)
        {   
            if(arr[i]>max)
                max=arr[i];
        }
        return max;
    }

    let add_extra_tile =(kk)=>{
        let key_val=0;
        if(kk=="ArrowRight"||kk=="d")
            key_val=1;
        else if(kk=="ArrowDown"||kk=="s")
            key_val=2;
        else if(kk=="ArrowLeft"||kk=="a")
            key_val=3;
        let v=get_random();
        // v=100;
        let p=get_empty_pos(number_state);
        let ind2=Math.floor(Math.random()*p.length);
        let ind=p[ind2];
        number_state[ind]=v;
        let ix=ind%4;
        let iy=Math.floor(ind/4);
        let init=true;
        grid_state.map((item)=>{
            if(item.number==0 &&init)
            {
                item.number=v;
                item.x=ix;
                item.y=iy;
                init=false;
                item.t_pos_direct(key_val);
            }
        
        })

    }

    let get_empty_pos=(arr)=>{
        let pos=[];
        for(let i=0;i<16;i++)
        {   
            if(arr[i]===0)
                pos.push(i);

        }
        return pos;
    }

    let is_game_over = ()=>{
        let p=get_empty_pos(number_state);
        if(p.length!=0)
        {
            return false;
        }
            
            
            let num=number_state;
            let new_num=[];
            let dummy=new Tile(0,0,0,17,border_thickness,p5_loc,[1,2,3]);
            for(let i=0;i<4;i++)
            {
                let ind=i*4;
                let row=[num[ind],num[ind+1],num[ind+2],num[ind+3]];
    
                //merging part
                for(let j=0;j<3;j++)
                {
                    for(let k=j+1;k<=3;k++)
                    {
                            if(row[j]===row[k] && row[j]!==0)
                        {
                                return false;
                        }   
                        if(row[k]!=0)
                            break;
                    }
                }
            }



        for(let i=0;i<4;i++)
        {
            let ind=i;
            let row=[num[0*4+ind],num[ind+1*4],num[ind+2*4],num[ind+3*4]];

            //merging part
            for(let j=0;j<3;j++)
            {
                for(let k=j+1;k<=3;k++)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                                return false;
                    }
                    if(row[k]!=0)
                        break;
                }
            }
        }
            return true;

    }

    let simulate_is_game_over = (ns1)=>{
        let p=get_empty_pos(ns1);
        if(p.length!=0)
        {
            return false;
        }
            
            
            let num=ns1;
            let new_num=[];
            let dummy=new Tile(0,0,0,17,border_thickness,p5_loc,[1,2,3]);
            for(let i=0;i<4;i++)
            {
                let ind=i*4;
                let row=[num[ind],num[ind+1],num[ind+2],num[ind+3]];
    
                //merging part
                for(let j=0;j<3;j++)
                {
                    for(let k=j+1;k<=3;k++)
                    {
                            if(row[j]===row[k] && row[j]!==0)
                        {
                                return false;
                        }   
                        if(row[k]!=0)
                            break;
                    }
                }
            }



        for(let i=0;i<4;i++)
        {
            let ind=i;
            let row=[num[0*4+ind],num[ind+1*4],num[ind+2*4],num[ind+3*4]];

            //merging part
            for(let j=0;j<3;j++)
            {
                for(let k=j+1;k<=3;k++)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                                return false;
                    }
                    if(row[k]!=0)
                        break;
                }
            }
        }
            return true;

    }
    
    // let [ai,setAi]=useState(false);
    let cts=false;
    let time_per_move=500;
    let ai_toggle=()=>{
        
        cts=!cts;
        do_a_move();

    }

    


    let do_a_move =()=>{
        move_simulation();
        if(cts)
            setTimeout(do_a_move,time_per_move);
    }


    return (
        <div className="sk_cont">
            <div className="game_title">2048</div>
            <div className="sketch_cont">
                {/* <div>poli</div> */}
            <Sketch setup={setup} draw={draw}
            // preload={preLoad}
            mousePressed={mousePressed} 
            keyPressed={keyPressed}
            />
                {/* <div>poli</div> */}

            </div>
            <div className="btn-holder">
                <button onClick={()=>ai_toggle()}>AI</button>
                <button onClick={()=>time_per_move=25}>speed</button>
                <button onClick={()=>time_per_move=100}>fast</button>
                <button onClick={()=>time_per_move=450}>medium</button>
                <button onClick={()=>time_per_move=2000}>slow</button>
            </div>
        </div>
    )
}

export default Game2
